import { create } from "zustand";

export type LocationGoogleMap = {
  longitude: number;
  latitude: number;
};

export type BoundingBoxGoogleMap = {
  topLeft: LocationGoogleMap;
  bottomRight: LocationGoogleMap;
};

export type GoogleMapPlace = {
  location: LocationGoogleMap | null;
  boundingBox: BoundingBoxGoogleMap | null;
  zoomUp: boolean;
};

export const getGooglePlaceState = create<GoogleMapPlace>(() => ({
  location: null,
  boundingBox: null,
  zoomUp: false,
}));

export const setGooglePlace = (googlePlace: GoogleMapPlace) => {
  getGooglePlaceState.setState(googlePlace);
};

export const setZoomUp = (zoomUp: boolean) => {
  getGooglePlaceState.setState(() => ({ zoomUp }));
};
